import { render, staticRenderFns } from "./AboutEnercredMobile.vue?vue&type=template&id=67a254f8&scoped=true"
import script from "./AboutEnercredMobile.vue?vue&type=script&lang=js"
export * from "./AboutEnercredMobile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67a254f8",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VContainer,VImg,VRow})


/* hot reload */
if (module.hot) {
  var api = require("/Users/afonsomonteiro/onboarding/onboarding/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('67a254f8')) {
      api.createRecord('67a254f8', component.options)
    } else {
      api.reload('67a254f8', component.options)
    }
    module.hot.accept("./AboutEnercredMobile.vue?vue&type=template&id=67a254f8&scoped=true", function () {
      api.rerender('67a254f8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/lp/AboutEnercredMobile.vue"
export default component.exports